import api from './_api';
import config from './_config';
import getContext from './_getContext';
import formValidation from './_formValidation';
import { useActiveSection } from './_useActiveSection';
import { getUser, checkUserRedirection } from './_getUser';
import useGetLangPath from './getLangPath';
import {
	stringToLetters,
	getRequestCookies,
	getCookie,
	setCookie,
	removeCookie,
	numToLocalString,
	handlePriceCheckFunc,
	cleanObject,
} from './_functions';

export {
	api,
	config,
	getContext,
	formValidation,
	getUser,
	checkUserRedirection,
	useActiveSection,
	stringToLetters,
	getRequestCookies,
	getCookie,
	setCookie,
	removeCookie,
	numToLocalString,
	handlePriceCheckFunc,
	cleanObject,
	useGetLangPath,
};
